<template>
    <div class="form-input form-input-select-countries">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field">
            <vue-multi-select
                :selectOptions="countries"
                search
                :multiple="true"
                :btnLabel="btnLabel"
                :options="{
                    multi: true,
                    labelSelected: 'selected',
                    cssSelected: (option) => ''
                }"
                v-model="element[field]"
            >
                <template v-slot:option="{ option }">
                    <input type="checkbox" class="form-input-checkbox" :checked="option.selected"/>
                    <img
                        v-if="option.image"
                        :src="option.image"
                        :alt="option.name"
                    />
                    <span :class="{ bold: option.selected }">{{ option.name }}</span>
                </template>
            </vue-multi-select>
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import { defaultLanguage, cmsLanguage } from '@/config/languages';
import api from '@/api';

export default {
    name: 'SelectCountries',
    components: {
        vueMultiSelect,
    },
    data() {
        return {
            btnLabel: (values) => (values.length > 0 ? values.map((country) => country.name).join(', ') : this.placeholder),
        };
    },
    props: {
        field: {
            type: String,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
        currentLanguage: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            required: false,
        },
    },
    computed: {
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
        countries() {
            return this.$store.state.countries.list.map((country) => {
                const name = typeof country.locales[cmsLanguage] !== 'undefined' ? country.locales[cmsLanguage].name : country.locales[defaultLanguage].name;
                return {
                    id: country.id,
                    key: country.key,
                    name,
                    image: this.getFlagUrl(country),
                };
            });
        },
    },
    methods: {
        getFlagUrl(item) {
            if (typeof item.flagimageid !== 'undefined' && item.flagimageid > 0) {
                return api.image.url(item.flagimageid);
            }
            return null;
        },
        getSelectedCountriesList(oo) {
            // const countries = this.selectedCountries.map(id => this.$store.getters['countries/getById'](id))
            console.log(oo);
            return '';
        },
    },
};
</script>
